export default __webpack_public_path__ + "static/media/Mulish-Light.2b8fbb0e.ttf";